import { z } from "zod";

export const medicalHistoryFormSchema = z.object({
  conditionCode: z.string().min(1, "Condition code is required"),
  conditionCodeDisplay: z.string().min(1, "Condition display is required"),
  existingEpisodeOfCareId: z.string().nullish(),
});

export const medicalHistoryNoteFormSchema = z.object({
  note: z.string().nullish(),
});

export const medicalHistoryMultiFormSchema = z.object({
  conditionCodes: z
    .array(
      z.object({
        conditionCode: z.string().min(1, "Condition code is required"),
        conditionCodeDisplay: z
          .string()
          .min(1, "Condition display is required"),
      }),
    )
    .min(1, "At least one condition is required"),
});
